import { Button } from "primereact/button";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVDate } from "../../shared/JVDate";
import { JVDropdownInput } from "../../shared/JVDropdownInput";
import { Dropdown } from "primereact/dropdown";
import { Controller, useForm } from "react-hook-form";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { useEffect, useState } from "react";
import { classNames } from "primereact/utils";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { IGetDateProps } from "./Form";
import { PaymentTerm } from "../../models/ConsultantMast";
import { BillingCycle } from "../showPurchaseOrder/GeneratePO";
import { Card } from "primereact/card";
import { SVInvoiceAdditionalExpenses } from "./SVInvoiceAdditionalExpenses";

interface IProps {
    singleData?: any,
    toast?: any,
    onHideSubvendorInv: any
    // setReload: (reload: boolean) => void,
    // reload: boolean,
};

export interface ISubvendorInvoice {
    id?: number,
    primevendorInvoice_ID?: number,
    pO_ID?: number,
    invoiceNO?: string,
    requestedAmount?: number,
    paymentStatus?: string,
    paidAmount?: number,
    payment_Mode?: string,
    transaction_ID?: string,
    fromDate?: Date,
    toDate?: Date,
    workingHours?: number,
    dueDate?: Date,
    subvendorCompany_ID?: {
        vendor_Company_ID: number,
        vendor_Company_Name: string,
    },
    consultant_ID?: {
        consultant_ID: number,
        pO_ID: number,
    },
    bRate?: number,
    recivedDate?: Date,
    isVerfied?: boolean
}

const schema = yup.object({
    subvendorCompany_ID: yup.object({
        vendor_Company_ID: yup.number().required(""),
        vendor_Company_Name: yup.string().required(""),
    }).required("Subvendor is Required"),
    //consultant_ID: yup.number().required("Consultant is Required"),
    consultant_ID: yup.object({
        consultant_ID: yup.number().required(""),
        pO_ID: yup.number().required(""),
    }).required("Consultant is Required"),
    primevendorInvoice_ID: yup.number().required("Primevendor Invoice Number is Required"),
    invoiceNO: yup.string().required("Invoice NO is Required").typeError("Invoice NO is Required"),
    requestedAmount: yup.number().required("Invoice Amount is required").typeError("Invoice Amount is required"),
    paymentStatus: yup.string().nullable(),
    paidAmount: yup.number().nullable(),
    payment_Mode: yup.string().nullable(),
    transaction_ID: yup.string().nullable(),
    fromDate: yup.date().required("From Date is Required"),
    toDate: yup.date().required("To Date is Required"),
    workingHours: yup.number().nullable(),
    dueDate: yup.date().required("Due Date is Required"),
    isVerfied: yup.boolean().nullable()
});

const EmptyForm: ISubvendorInvoice = {
    primevendorInvoice_ID: 0,
    invoiceNO: '',
    requestedAmount: 0,
    paymentStatus: '',
    paidAmount: 0,
    payment_Mode: '',
    transaction_ID: '',
    workingHours: 0
}

export const GenerateInvice = (props: IProps) => {
    const [subvendor_List, setSubvendor_List] = useState<any[]>([]);
    const [invoiceFile, setInvoiceFile] = useState<File | null | any>(null);
    const [uploadedInvoice, setUploadedInvoice] = useState(false);
    const [dispFields, setDispFields] = useState({ Consultant: true, Primevendor: true } as { Consultant: boolean, Primevendor: boolean });
    const [consultant_List, setConsultant_List] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [invAmnt, setInvAmnt] = useState<number>(0);
    const [additionalExpensesDocList, setAdditionalExpensesDocList] = useState<Array<{ id: any, description: string, hours: number, rate: number, amount: number }>>([]);
    const [additionalExpensesList, setAdditionalExpensesList] = useState<Array<{ id: any, description: string, hours: number, rate: number, amount: number }>>([]);

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue, setError, setFocus } = useForm<ISubvendorInvoice>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const Payment_Status = [
        { name: "-- SELECT --", value: null },
        { name: "Pending", value: "Pending" },
        { name: "Paid", value: "Paid" },
        { name: "Balance", value: "Balance" },
        { name: "Over Payment", value: "Over Payment" },
    ];
    const Payment_Mode = [
        { name: "-- SELECT --", value: null },
        { name: "Cheque", value: "CHEQUE" },
        { name: "NetBanking", value: "NET BANKING" },
        { name: "UPI", value: "UPI" },
        { name: "PayPal", value: "PAYPAL" },
    ];

    const loadSubvendor = async (query: string) => {
        const response = await Fetch("Dropdown/sub_vendor_companies", "GET", null, `filter=${query}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            setSubvendor_List(data);
        }
    };

    const completeMethodSubvendor = (event: { query: string }) => {
        loadSubvendor(event.query);
    };

    const onSubmit = async (data: ISubvendorInvoice) => {
        if (data.requestedAmount !== undefined && data.requestedAmount !== null && data.requestedAmount > 0 && data.requestedAmount > (invAmnt + additionalExpensesDocList.reduce((sum, el) => sum + (el.amount || 0), 0))) {
            props.toast.current.show({ severity: 'error', detail: "Description Is Required In All Additional Expenses", life: 3000 });
        } else if (additionalExpensesDocList.length > 0 && additionalExpensesDocList.filter((el: { id: any, description: string, hours: number, rate: number, amount: number }) => el.description.trim() === "").length > 0) {
            props.toast.current.show({ severity: 'error', detail: "Description Is Required In All Additional Expenses", life: 3000 });
        } else if (additionalExpensesDocList.length > 0 && additionalExpensesDocList.filter((el: { id: any, description: string, hours: number, rate: number, amount: number }) => el.hours === 0).length > 0) {
            props.toast.current.show({ severity: 'error', detail: "Hours Cannot be 0 In Aany Additional Expenses", life: 3000 });
        } else if (additionalExpensesDocList.length > 0 && additionalExpensesDocList.filter((el: { id: any, description: string, hours: number, rate: number, amount: number }) => el.rate === 0).length > 0) {
            props.toast.current.show({ severity: 'error', detail: "Rate Cannot be 0 In Aany Additional Expenses", life: 3000 });
        } else if (additionalExpensesDocList.length > 0 && additionalExpensesDocList.filter((el: { id: any, description: string, hours: number, rate: number, amount: number }) => el.amount === 0).length > 0) {
            props.toast.current.show({ severity: 'error', detail: "Amount Cannot be 0 In Aany Additional Expenses", life: 3000 });
        } else if (data.paymentStatus === "Paid" && (data.paidAmount || 0) !== Number(invAmnt || 0)) {
            props.toast.current.show({ severity: 'error', detail: "Pay Amount dose not match to Payment Status and Invoice Amount", life: 3000 });
        } else if (data.paymentStatus === "Balance" && (data.paidAmount || 0) >= Number(invAmnt || 0)) {
            props.toast.current.show({ severity: 'error', detail: "Pay Amount dose not match to Payment Status and Invoice Amount", life: 3000 });
        } else if (data.paymentStatus === "Over Payment" && (data.paidAmount || 0) <= Number(invAmnt || 0)) {
            props.toast.current.show({ severity: 'error', detail: "Pay Amount dose not match to Payment Status and Invoice Amount", life: 3000 });
        } else {
            if (invoiceFile === null && (props?.singleData?.id == null || props?.singleData?.id == 0)) {
                props.toast.current.show({ severity: 'error', detail: "Please Upload Subvendor Invoice First", life: 3000 });
            } else {
                let newData: any = {
                    consultant_ID: data?.consultant_ID?.consultant_ID,
                    primevendorInvoice_ID: data.primevendorInvoice_ID,
                    pO_ID: data?.consultant_ID?.pO_ID,
                    invoiceNO: data.invoiceNO,
                    invoiceAmount: invAmnt,
                    requestedAmount: data.requestedAmount,
                    paymentStatus: data.paymentStatus,
                    paidAmount: data.paidAmount,
                    payment_Mode: data.payment_Mode,
                    transaction_ID: data.transaction_ID,
                    fromDate: data.fromDate,
                    toDate: data.toDate,
                    workingHours: data.workingHours,
                    dueDate: data.dueDate,
                    subvendorCompany_ID: data?.subvendorCompany_ID?.vendor_Company_ID,
                    bRate: props?.singleData?.bRate || 0,
                    isVerfied: data.isVerfied,
                    generated_Date: data.recivedDate,

                };

                let updateData: any = {
                    id: props.singleData.id,
                    invoiceNO: newData.invoiceNO,
                    primevendorInvoice_ID: newData.primevendorInvoice_ID,
                    pO_ID: newData.pO_ID,
                    invoiceAmount: newData.invoiceAmount,
                    fromDate: newData.fromDate,
                    toDate: newData.toDate,
                    dueDate: newData.dueDate,
                    consultant_ID: newData.consultant_ID,
                    requestedAmount: newData.requestedAmount,
                    workingHours: newData.workingHours,
                    subvendorCompany_ID: newData.subvendorCompany_ID,
                    bRate: newData.bRate,
                    paymentStatus: newData.paymentStatus,
                    paidAmount: newData.paidAmount,
                    payment_Mode: newData.payment_Mode,
                    transaction_ID: newData.transaction_ID,
                    isVerfied: newData.isVerfied,
                    generated_Date: newData.recivedDate,

                }

                if (uploadedInvoice === false && (props?.singleData?.id == null || props?.singleData?.id == 0)) {
                    props.toast.current.show({ severity: 'error', content: "Please Upload Subvendor Invoice First." });
                } else {
                    setLoading(true);

                    const areSame: boolean = JSON.stringify(additionalExpensesDocList) === JSON.stringify(additionalExpensesList);

                    const newDataA: { description: string, hours: number, rate: number, amount: number }[] = additionalExpensesDocList.map((el: { id: any, description: string, hours: number, rate: number, amount: number }) => {
                        return { description: el.description, hours: el.hours, rate: el.rate, amount: el.amount };
                    });

                    const method = (props.singleData?.id != 0 && props.singleData?.id != null) ? "PUT" : "POST";
                    const message = (props.singleData?.id != 0 && props.singleData?.id != null) ? "Updated Successfully" : "Added Successfully";

                    const formData = new FormData();
                    formData.append('file', invoiceFile);
                    formData.append('newInvoice', JSON.stringify((props?.singleData?.id == null || props?.singleData?.id == 0) ? newData : updateData));
                    if (areSame === false) formData.append('additionals', JSON.stringify(newDataA));
                    const params = {
                        method: method,
                        headers: {
                            'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
                        },
                        body: formData
                    };

                    const response = await fetch(`${baseUrl}InvoiceTracking/subvendorInvoice`, params);

                    if (response.ok) {
                        const data: any = await response.json();
                        props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                        props.onHideSubvendorInv();
                        setLoading(false);
                        setAdditionalExpensesDocList([]);
                        // props.setReload(!props.reload);
                        reset({});
                    } else {
                        const message2 = await response.text();
                        props.toast.current.show({ severity: 'error', detail: message2, life: 3000 });
                        setLoading(false);
                    }
                }
            }
        }
    };

    const invoiceUpload = (event: FileUploadHandlerParam) => {
        if (event.files[0]) {
            if (event.files[0].size > 1024 * 1024 * 5) {
                props.toast.current.show({ severity: 'error', content: "File should be less than 5 MB." });
                event.options.clear();
            } else {
                setInvoiceFile(event.files[0]);
                setUploadedInvoice(true);
                props.toast.current.show({ severity: 'success', content: "File Selected" });
                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A File." });
            event.options.clear();
        }
    };

    const getTimesheetHours = async (fromDate: Date, toDate: Date) => {

        const response = await Fetch("Timesheet/getTimesheetHours", "POST", {
            PO_ID: props.singleData.pO_ID,
            FromDate: fromDate,
            ToDate: toDate
        }, null, props.toast);

        if (response) {
            const data: any = await response.json();

            setValue('workingHours', data.hours);
            setInvAmnt(prev => prev = (Number(data.hours || 0) * (props.singleData.bRate || 0)));
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "fromDate") {
                if (value.fromDate != null) {
                    getTimesheetHours(value.fromDate, control._formValues.toDate);
                }
            }
            if (name === "toDate") {
                if (value.toDate != null) {
                    getTimesheetHours(control._formValues.fromDate, value.toDate);
                }
            }
            if (name === "recivedDate") {
                if (value.recivedDate != null && value.recivedDate != undefined) {
                    if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Net_Thirty) {
                        setValue("dueDate", new Date(new Date(value.recivedDate || new Date()).getMonth() + 1 === 12 ? new Date(value.recivedDate || new Date()).getFullYear() + 1 : new Date(value.recivedDate || new Date()).getFullYear(), 1, 0));
                    }
                    else if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Net_Forty_Five) {
                        setValue("dueDate", new Date(new Date().setDate(new Date(value.recivedDate || new Date()).getDate() + 45)));
                    }
                    else if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Pay_On_Pay) {
                        //props.singleData.dueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
                    }
                    else if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Net_Fifteen) {
                        setValue("dueDate", new Date(new Date().setDate(new Date(value.recivedDate || new Date()).getDate() + 15)));
                    }
                    else if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Net_Sixty) {
                        setValue("dueDate", new Date(new Date().setDate(new Date(value.recivedDate || new Date()).getDate() + 60)));
                    }
                    else if (props.singleData.sub_Vendor_Payment_Term === PaymentTerm.Net_Seven) {
                        setValue("dueDate", new Date(new Date().setDate(new Date(value.recivedDate || new Date()).getDate() + 7)));
                    };
                }
            }
            if (name === "fromDate") {
                if (value.fromDate != null && value.fromDate != undefined) {
                    if (props.singleData.sub_Vendor_Billing_Cycle === BillingCycle.Monthly) {
                        setValue("toDate", new Date(new Date().setDate(new Date(value.fromDate || new Date()).getDate() + 30)));
                    }
                    else if (props.singleData.sub_Vendor_Billing_Cycle === BillingCycle.BiWeekly) {
                        let newToDate = new Date(new Date().setDate(new Date(value.fromDate || new Date()).getDate() + 15));
                        // let currentYear = value.fromDate.getFullYear();
                        // let currentMonth = value.fromDate.getMonth();
                        // if (newToDate.getDate() <= 15) {
                        //     let nextMonth: Date = new Date(currentYear, currentMonth, 15);
                        //     setValue("toDate", nextMonth);
                        //     //new Date(currentYear, currentMonth + 1, 1)
                        // } else if (newToDate.getDate() >= 1 && newToDate.getDate() < 15) {
                        //     // Create a date object for the first day of the next month
                        //     let nextMonth: Date = new Date(currentYear, currentMonth + 1, 1);

                        //     // Subtract one day to get the last day of the current month
                        //     let lastDayOfMonth = new Date((nextMonth).getDate() - 1);
                        //     setValue("toDate", lastDayOfMonth);
                        // } else {
                        //     setValue("toDate", new Date(new Date().setDate(new Date(value.fromDate || new Date()).getDate() + 15)));
                        // }
                        setValue("toDate", new Date(new Date().setDate(new Date(value.fromDate || new Date()).getDate() + 15)));
                    }
                    else if (props.singleData.sub_Vendor_Billing_Cycle === BillingCycle.Weekly) {
                        setValue("toDate", new Date(new Date().setDate(new Date(value.fromDate || new Date()).getDate() + 7)));
                    }
                }
            }
            if (name === "workingHours") {
                if (value.workingHours != null && value.workingHours != 0 && value.workingHours != undefined) {
                    setInvAmnt(prev => prev = ((value.workingHours || 0) * props.singleData.bRate));
                    //setValue("requestedAmount", ((value.workingHours || 0) * props.singleData.bRate));
                }
            }
            if (name === "requestedAmount") {
                if (value.requestedAmount != null && value.requestedAmount != 0) {
                    if (value.requestedAmount > (invAmnt + additionalExpensesDocList.reduce((sum, el) => sum + (el.amount || 0), 0))) {
                        setError("requestedAmount", { message: "Requested Amount can not be greater than Invoice Amount" }, { shouldFocus: true });
                    } else {
                        setError("requestedAmount", { message: "" }, { shouldFocus: false });
                    }
                }
            }
        });
        return () => subscription.unsubscribe();

    }, [watch, invAmnt, additionalExpensesDocList]);

    useEffect(() => {
        if (props.singleData.pO_ID) {

            let consultantID = {
                consultant_ID: props.singleData.consultant_ID,
                consultant_Name: props.singleData.consultant_Name + ` ( ${props.singleData.primeVendor_Company_Name} )`,
                pO_ID: props.singleData.pO_ID,
            };

            setConsultant_List(prev => prev = [consultantID]);
            let invData: any = {
                primevendorInvoice_ID: props.singleData.primevendorInvoice_ID,
                pO_ID: props.singleData.pO_ID,
                invoiceNO: null,
                requestedAmount: (props.singleData.workingHours || 0) * props.singleData.bRate,
                paymentStatu: null,
                paidAmount: null,
                payment_Mode: null,
                transaction_ID: null,
                fromDate: props.singleData.fromDate,
                toDate: props.singleData.toDate,
                workingHours: props.singleData.workingHours,
                dueDate: new Date(),
                subvendorCompany_ID: {
                    vendor_Company_ID: props.singleData.vendor_Company_ID,
                    vendor_Company_Name: props.singleData.vendor_Company_Name,
                },
                consultant_ID: consultantID,
                bRate: props.singleData.bRate,
                recivedDate: new Date(),
            };

            let po = { pO_ID: props.singleData.pO_ID, billing_Cycle: "", payment_Term: "" };
            let recent = { pO_ID: props.singleData.pO_ID };
            let singleData = { pO_ID: props.singleData.pO_ID, fromDate: null, toDate: null, dueDate: null };

            if (props.singleData.sub_Vendor_Billing_Cycle !== props.singleData.prime_Vendor_Billing_Cycle) {
                invData.workingHours = null;
                invData.requestedAmount = (0) * props.singleData.bRate;
                invData.dueDate = getDueDate(invData.recivedDate, props.singleData.sub_Vendor_Payment_Term);
                reset(invData);
            } else {
                setInvAmnt((props.singleData.workingHours || 0) * props.singleData.bRate);
                invData.dueDate = getDueDate(invData.recivedDate, props.singleData.sub_Vendor_Payment_Term);
                reset(invData);
            }

            if (props.singleData.fromDate != null, props.singleData.toDate != null) {
                getTimesheetHours(props.singleData.fromDate, props.singleData.toDate);
            }
        }
    }, []);

    return (
        <>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdownInput required={true} disabled={true} column={3} completeMethod={completeMethodSubvendor} label="Subvendor" control={control} name="subvendorCompany_ID" error={errors.subvendorCompany_ID?.message} options={subvendor_List} optionLabel="vendor_Company_Name" placeholder="Search Subvendor" />

                {/* <JVDropdown required disabled={dispFields.Consultant} column={3} label="Consultant" control={control} name="consultant_ID" options={consultant_List} optionLabel="consultant_Name" optionValue="consultant_ID" placeholder="Select Consultant" error={errors.consultant_ID?.message} /> */}
                <div className={'field col-12 md:col-4'}>
                    <label>Consultant<span style={{ color: 'red' }}>*</span></label>
                    <Controller name={'consultant_ID'} control={control} render={({ field, fieldState }: any) => (
                        <Dropdown inputId={field.name} disabled={dispFields.Consultant} {...field} options={consultant_List} optionLabel={'consultant_Name'} value={field.value} placeholder={"Select Consultant"} className={classNames({ 'p-invalid': fieldState.invalid })} filter={true} />
                    )} />
                    <small className="p-error" >{errors.consultant_ID?.message}</small>
                </div>
                {/* <JVDropdown required disabled={dispFields.Primevendor} column={3} label="Primevendor Invoice Number" control={control} name="primevendorInvoice_ID" options={allPrimeVendorInvoices} optionLabel="invoiceNO" optionValue="invoice_ID" placeholder="Select Invoice" itemTemplate={primeVendorInvoiceOptionTemplate} valueTemplate={selectedPrimeVendorInvoiceTemplate} error={errors.primevendorInvoice_ID?.message} /> */}

                {/* <JVDropdown column={3} label="Payment Status" control={control} name="paymentStatus" options={Payment_Status} optionLabel="name" optionValue="name" placeholder="Select Payment Status" error={errors.paymentStatus?.message} /> */}
                <JVDate required column={3} label="Inv Generating Date" control={control} name="recivedDate" error={errors.recivedDate?.message} />
                <JVDate required column={3} maxDate={new Date()} label="From Date" control={control} name="fromDate" error={errors.fromDate?.message} />
                <JVDate required column={3} maxDate={new Date()} label="To Date" control={control} name="toDate" error={errors.toDate?.message} />
                <JVDate required column={3} label="Due Date" control={control} name="dueDate" error={errors.dueDate?.message} />
                <JVInput required column={3} disabled={props.singleData.sub_Vendor_Billing_Cycle === props.singleData.prime_Vendor_Billing_Cycle} label="Working Hours" control={control} name="workingHours" error={errors.workingHours?.message} />
                <div className={'field col-12 md:col-4'}>
                    <label>B. Rate</label>
                    <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{props.singleData.bRate}</p>
                </div>
                <div className={'field col-12 md:col-4'}>
                    <label>Invoice Amount</label>
                    <p className="border-1 border-round border-400 pl-2 pt-2" style={{ height: "34px" }}>{(control._formValues.workingHours || 0) * props.singleData.bRate}</p>
                </div>
                <Button style={{ marginLeft: "96%", width: "2rem", height: "2rem" }} icon="pi pi-plus" type="button" tooltip="Click To Add Rowa To Add Additional Exprenses" onClick={() => setAdditionalExpensesDocList([...additionalExpensesDocList, { id: crypto.randomUUID(), description: "", hours: 0, rate: 0, amount: 0 }])} />
                {additionalExpensesDocList.length > 0 && <Card className={'field col-12 md:col-12'} style={{ width: "98%", marginLeft: "15px" }}>
                    <div className="field col-12 md:col-12 flex">
                        <b>Additional Expenses</b>
                    </div>
                    <div style={{ maxHeight: "30rem", overflowY: "scroll" }}>
                        {additionalExpensesDocList.map(((el: { id: any, description: string, hours: number, rate: number, amount: number }) => <SVInvoiceAdditionalExpenses list={additionalExpensesDocList} setList={setAdditionalExpensesDocList} id={el.id} description={el.description} hours={el.hours} rate={el.rate} amount={el.amount} toast={props.toast} />))}
                    </div>
                </Card>}
                <JVInput required column={3} label="Invoice Number" control={control} name="invoiceNO" error={errors.invoiceNO?.message} />
                <JVInput required column={3} label="Requested Amount" control={control} name="requestedAmount" error={errors.requestedAmount?.message} />
                {/* <JVDropdown column={3} label="Payment Status" control={control} name="paymentStatus" options={Payment_Status} optionLabel="name" optionValue="name" placeholder="Select Payment Status" error={errors.paymentStatus?.message} />
                <JVInput column={3} label="Paid Amount" control={control} name="paidAmount" error={errors.paidAmount?.message} />
                <JVDropdown column={3} label="Payment Mode" control={control} name="payment_Mode" options={Payment_Mode} optionLabel="name" optionValue="value" placeholder="Select Payment Mode" error={errors.payment_Mode?.message} />
                <JVInput column={3} label="Transaction ID" control={control} name="transaction_ID" error={errors.transaction_ID?.message} /> */}
                <div className="field col-12 md:col-2">
                    <span className="">Invoice <span style={{ color: 'red' }}>*</span></span>
                    <FileUpload className="mt-2" chooseLabel="Choose Invoice" mode="basic" name="invoice" accept=".pdf" customUpload auto uploadHandler={invoiceUpload} />
                </div>
                {props.singleData?.invoiceNO && <div className="field col-12 md:col-2 pt-5">
                    <JVCheckbox label="Verify" control={control} name="isVerfied" />
                </div>}
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6 h-2rem" label="SAVE" type="submit" loading={loading}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLEAR" onClick={() => { setAdditionalExpensesDocList([]); }} type="button"></Button>
                </div>
            </form>
        </>
    );
}


const getDueDate = (invDate: Date, payment_Term: PaymentTerm) => {
    let dueDate = new Date();
    if (payment_Term === PaymentTerm.Net_Thirty) {
        dueDate = new Date(new Date(invDate || new Date()).getMonth() + 1 === 12 ? new Date(invDate || new Date()).getFullYear() + 1 : new Date(invDate || new Date()).getFullYear(), 1, 0);
    }
    else if (payment_Term === PaymentTerm.Net_Forty_Five) {
        dueDate = new Date(new Date().setDate(new Date(invDate || new Date()).getDate() + 45));
    }
    else if (payment_Term === PaymentTerm.Pay_On_Pay) {
        //props.singleData.dueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
    }
    else if (payment_Term === PaymentTerm.Net_Fifteen) {
        dueDate = new Date(new Date().setDate(new Date(invDate || new Date()).getDate() + 15));
    }
    else if (payment_Term === PaymentTerm.Net_Sixty) {
        dueDate = new Date(new Date().setDate(new Date(invDate || new Date()).getDate() + 60));
    }
    else if (payment_Term === PaymentTerm.Net_Seven) {
        dueDate = new Date(new Date().setDate(new Date(invDate || new Date()).getDate() + 7));
    };

    return dueDate;
}

const getFromToDates = (billing_Cycle: BillingCycle, project_Start_Date: Date, project_End_Date: Date, recent: any) => {
    let fromDate = new Date();
    let toDate = new Date();
    let invoiceDate = new Date();
    let dueDate: Date | null = new Date();

    if (billing_Cycle === BillingCycle.Monthly) {
        if (recent?.toDate === null || recent?.toDate === undefined) {
            var month = new Date(project_Start_Date || "");
            var lastDayOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0);

            fromDate = new Date(project_Start_Date || "");
            toDate = new Date(lastDayOfMonth.toString());
        } else if (recent?.toDate !== null) {
            let getFromDateFullyear = new Date(recent.toDate || "").getMonth() + 1 === 12 ? new Date(recent.toDate || "").getFullYear() + 1 : new Date(recent.toDate || "").getFullYear();
            let getFromDateMonth = new Date(recent.toDate || "").getMonth() + 1 === 12 ? 0 : new Date(recent.toDate || "").getMonth() + 1;

            fromDate = new Date(getFromDateFullyear, getFromDateMonth, 1);

            var lastDayOfMonth = new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 0);
            toDate = new Date(lastDayOfMonth.toString());
        }
    }
    if (billing_Cycle === BillingCycle.Weekly) {
        if (recent?.toDate === null || recent?.toDate === undefined) {
            fromDate = new Date(project_Start_Date || "");
            const currentDate = new Date(project_Start_Date || "");
            let numberOfDaysToAdd = (7 - Number(new Date(project_Start_Date || "")?.getDay())) - 2;
            const toDatE = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
            toDate = toDatE;

        } else if (recent?.toDate !== null) {
            const fromDatE = new Date(new Date(recent.toDate || "").setDate(new Date(recent.toDate || "").getDate() + 3));
            fromDate = fromDatE;
            const toDatE = new Date(new Date(recent.toDate || "").setDate(new Date(recent.toDate || "").getDate() + 7));
            toDate = toDatE;
        }
    }
    if (billing_Cycle === BillingCycle.BiWeekly) {
        if (recent?.toDate === null || recent?.toDate === undefined) {

            fromDate = new Date(project_Start_Date || "");
            const currentDate = new Date(project_Start_Date || "");
            let numberOfDaysToAdd = (7 - Number(new Date(project_Start_Date || "")?.getDay())) - 2;
            // const toDatE = new Date(currentDate.setDate(currentDate.getDate() + (numberOfDaysToAdd + 7)));

            let toDateYear = fromDate.getFullYear();
            let toDateMonth = fromDate.getMonth();
            let toDateDay = fromDate.getDate() < 16 ? 15 : new Date(fromDate.getFullYear(), fromDate.getMonth() + 1, 0).getDate();

            toDate = new Date(toDateYear, toDateMonth, toDateDay);

        } else if (recent?.toDate !== null) {
            let toDateYear = new Date(recent.toDate || "").getMonth() + 1 === 12 ? new Date(recent.toDate || "").getFullYear() + 1 : new Date(toDate || "").getFullYear();
            let toDateMonth = new Date(recent.toDate || "").getMonth() + 1 === 12 ? 0 : new Date(recent.toDate || "").getMonth() + 1;
            let toDateDay = new Date(recent.toDate || "").getDate() > 15 ? 1 : 16;

            const fromDatE = new Date(toDateYear, toDateMonth, toDateDay);
            fromDate = fromDatE;

            const toDatE = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate() < 16 ? 15 : new Date(fromDate.getFullYear(), fromDate.getMonth(), 0).getDate());
            toDate = toDatE;

        }
    }
    if (new Date(toDate || "") > new Date(project_End_Date || "") && recent?.pO_ID) {
        toDate = new Date(project_End_Date || "");
        invoiceDate = new Date(project_End_Date || "");
        dueDate = null;
    }

    return { fromDate: fromDate, toDate: toDate, invoiceDate: invoiceDate, dueDate: dueDate }
}